import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import data from "../data/content.json";

const SystemLoader = ({ onComplete }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const totalDuration = data.preloader.duration;
    const intervalTime = totalDuration / 100;

    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          // Pequeña pausa al llegar al final para que se vea la línea completa
          setTimeout(() => {
            setIsVisible(false);
            onComplete(); 
          }, 400);
          return 100;
        }
        return prev + 1;
      });
    }, intervalTime);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div 
          exit={{ opacity: 0 }}
          className="fixed top-0 left-0 w-full z-[1000] pointer-events-none"
        >
          {/* Únicamente la línea de carga con resplandor */}
          <motion.div 
            className="h-[4px] bg-brand-accent shadow-[0_0_15px_rgba(46,204,113,0.8)]"
            initial={{ width: 0 }}
            animate={{ width: `${count}%` }}
            transition={{ ease: "linear" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SystemLoader;
/*<!--© 2026 Todos los derechos reservados Desarrollado por JEMAprod-Tecnologia-->*/